/* ============================================================
   TEMA: "Copy of Copy of Horizon" (tema PUBLICADO de citric.mx)
   ARCHIVO: assets/citric-custom.js
   Versión: 28-oct-2026 v7 (v6 + opción "Todos" hasta arriba dentro de cada marca del menú)
   ============================================================ */
/* Citric · ajustes Horizon */
(function () {
  var norm = function (s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  };

  /* Buscador de marcas: va hasta arriba de la lista "Todas las marcas" y la filtra mientras escribes.
     Vive DENTRO de la misma lista (antes iba en el menú de arriba, que en celular queda bloqueado al abrir el submenú y no dejaba escribir) */
  function initBrandSearch(root) {
    var triggers = (root || document).querySelectorAll('[id*="todas-las-marcas" i]');
    triggers.forEach(function (trigger) {
      if (trigger.closest('.citric-brand-list, .citric-brand-search')) return;
      var container = trigger.closest('details') || trigger.closest('li') || trigger.parentElement;
      if (!container) return;
      var list = container.querySelector('ul');
      if (!list || list.dataset.citricSearch) return;
      list.dataset.citricSearch = '1';
      list.classList.add('citric-brand-list');

      var wrap = document.createElement('li');
      wrap.className = 'citric-brand-search';
      wrap.innerHTML =
        '<input type="search" placeholder="Buscar marca…" aria-label="Buscar marca" autocomplete="off" inputmode="search">' +
        '<div class="citric-brand-search__empty">Sin resultados</div>';
      list.insertBefore(wrap, list.firstElementChild);

      var input = wrap.querySelector('input');
      var empty = wrap.querySelector('.citric-brand-search__empty');
      /* que el menú no se robe las teclas ni cierre el panel al tocar el buscador */
      ['keydown', 'keyup', 'keypress', 'click', 'pointerdown', 'mousedown'].forEach(function (ev) {
        input.addEventListener(ev, function (e) { e.stopPropagation(); });
      });
      input.addEventListener('input', function () {
        var q = norm(input.value), shown = 0;
        Array.prototype.forEach.call(list.children, function (li) {
          if (li === wrap) return;
          var name = norm(li.textContent.replace(/\s+/g, ' '));
          var ok = !q || name.indexOf(q) !== -1;
          li.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        empty.style.display = q && !shown ? 'block' : 'none';
      });
    });
  }

  /* Contador de ofertas relámpago (termina a medianoche, hora local) */
  function initFlashTimers() {
    var timers = document.querySelectorAll('[data-citric-countdown]');
    if (!timers.length) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      timers.forEach(function (t) {
        var b = t.querySelectorAll('b');
        if (b.length === 3) { b[0].textContent = pad(h); b[1].textContent = pad(m); b[2].textContent = pad(sec); }
      });
    };
    tick(); setInterval(tick, 1000);
  }

  /* Barra inferior en celular */
  function buildTabbar() {
    if (document.querySelector('.citric-tabbar')) return document.querySelector('.citric-tabbar');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var path = location.pathname.replace(/\/$/, '') || '/';
    var isHome = path === '/' || path === root.replace(/\/$/, '');
    var ico = {
      home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 10.5 12 3l9 7.5V21H3z"/><path d="M9 21v-6h6v6"/></svg>',
      grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>',
      search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
      user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>',
      cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6"/><circle cx="10" cy="20.5" r="1"/><circle cx="17" cy="20.5" r="1"/></svg>'
    };
    var nav = document.createElement('nav');
    nav.className = 'citric-tabbar';
    nav.setAttribute('aria-label', 'Navegación rápida');
    nav.innerHTML =
      '<a href="' + root + '"' + (isHome ? ' class="is-active"' : '') + '>' + ico.home + '<span>Inicio</span></a>' +
      '<button type="button" data-citric-action="menu">' + ico.grid + '<span>Categorías</span></button>' +
      '<a href="' + root + 'search" data-citric-action="search">' + ico.search + '<span>Buscar</span></a>' +
      '<a href="' + root + 'account">' + ico.user + '<span>Cuenta</span></a>' +
      '<a href="' + root + 'cart" data-citric-action="cart">' + ico.cart + '<span>Carrito</span></a>';
    document.body.appendChild(nav);
    return nav;
  }

  function initTabbar() {
    var bar = buildTabbar();
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-citric-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-citric-action');
      var target = null;
      if (action === 'menu') target = document.querySelector('#header-component .header__icon--menu');
      if (action === 'search') target = document.querySelector('#header-component .search-action button, #header-component search-button button, #header-component [aria-controls*="search" i]');
      if (action === 'cart') target = document.querySelector('#header-component .header-actions__cart-icon, #header-component cart-icon button, #header-component [href$="/cart"]');
      if (target) { e.preventDefault(); target.click(); }
    });
  }

  /* Fotos por color: en la ficha solo se ven las fotos cuyo texto alternativo (alt) es el color elegido.
     Las fotos sin alt de color se ven siempre. */
  function selectedColor() {
    var groups = document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset, [class*="variant-option"]');
    for (var i = 0; i < groups.length; i++) {
      var legend = groups[i].querySelector('legend, label, .variant-option__name');
      if (!legend || norm(legend.textContent).indexOf('color') === -1) continue;
      var checked = groups[i].querySelector('input:checked');
      if (checked) return { value: norm(checked.value), all: Array.prototype.map.call(groups[i].querySelectorAll('input'), function (n) { return norm(n.value); }) };
      var sel = groups[i].querySelector('select');
      if (sel) return { value: norm(sel.value), all: Array.prototype.map.call(sel.options, function (o) { return norm(o.value); }) };
    }
    return null;
  }

  function filterMediaByColor() {
    var c = selectedColor();
    if (!c) return;
    var gallery = document.querySelector('media-gallery, .product-media-gallery, .product__media-wrapper, product-media-gallery');
    if (!gallery) return;
    var items = gallery.querySelectorAll('slideshow-slide, .product-media-container, li, .slideshow-controls__thumbnail, button[class*="thumbnail"]');
    var shown = 0, firstSlide = null;
    items.forEach(function (it) {
      var img = it.querySelector('img');
      if (!img) return;
      var alt = norm(img.getAttribute('alt'));
      var ok = c.all.indexOf(alt) === -1 || alt === c.value;
      if (it.style.display !== (ok ? '' : 'none')) it.style.display = ok ? '' : 'none';
      if (ok) { shown++; if (!firstSlide && it.tagName === 'SLIDESHOW-SLIDE') firstSlide = it; }
    });
    if (!shown) items.forEach(function (it) { it.style.display = ''; });
    /* Al cambiar de color, regresar el carrusel a la primera foto visible (si no, se queda en un hueco) */
    var track = firstSlide && firstSlide.parentElement;
    if (track && gallery.dataset.citricColor !== c.value) {
      gallery.dataset.citricColor = c.value;
      if (track.scrollTo) track.scrollTo({ left: firstSlide.offsetLeft - track.offsetLeft, behavior: 'auto' });
    }
  }

  /* Colores disponibles debajo de cada producto en las colecciones */
  var COLOR_HEX = { negro: '#111', blanco: '#fff', gris: '#9e9e9e', 'gris oscuro': '#555', 'gris claro': '#ccc', azul: '#1e5bc6', 'azul marino': '#1b2a4a', marino: '#1b2a4a', rojo: '#d32f2f', rosa: '#f4a6c0', fucsia: '#e0218a', morado: '#7b3fa0', lila: '#c8a2c8', verde: '#2e7d32', amarillo: '#fbc02d', naranja: '#f57c00', cafe: '#6d4c41', 'cafe oscuro': '#4e342e', marron: '#8d5524', camel: '#c19a6b', beige: '#e8d8b9', arena: '#d8c3a5', plata: '#c0c0c0', dorado: '#d4af37', vino: '#7b1e3a', durazno: '#ffcba4', turquesa: '#30c5c5', moka: '#6f4e37', natural: '#efe6d2', camuflaje: '#6b6b3a', multicolor: 'conic-gradient(red,orange,yellow,green,blue,violet,red)', caqui: '#b5a27a', khaki: '#b5a27a', cobre: '#b87333', plateado: '#c0c0c0', oro: '#d4af37', 'oro rosa': '#e0a899', 'rose gold': '#e0a899', hueso: '#f2ead3', crema: '#f3e5c0', marfil: '#fffff0', guinda: '#7b1e3a', mostaza: '#d4a017', celeste: '#87ceeb', cielo: '#87ceeb', rey: '#1e3fa0', mocha: '#6f4e37', perla: '#efe9e1', transparente: 'repeating-linear-gradient(45deg,#fff 0 4px,#e6e6e6 4px 8px)', brillos: 'linear-gradient(135deg,#e6e6e6,#fff,#c9c9c9,#fff)', tornasol: 'linear-gradient(135deg,#a8e6ff,#f5b3ff,#fff3a8)', cromado: 'linear-gradient(135deg,#888,#eee,#888)', grafito: '#3b3b3b', tan: '#d2b48c', caramelo: '#c68e17', vino: '#7b1e3a' };
  var cache = {};
  function colorDots(card) {
    if (card.dataset.citricColors) return;
    /* Si el tema ya pinta sus propios círculos de color en la tarjeta, no agregar otros (salían repetidos) */
    if (card.querySelector('[class*="swatch"]:not(.citric-colors), swatches-variant-picker-component')) return;
    if (card.querySelector('.citric-colors')) return;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    card.dataset.citricColors = '1';
    var handle = link.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var p = cache[handle] || (cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
    p.then(function (prod) {
      if (!prod) return;
      var idx = (prod.options || []).findIndex(function (o) { return norm(o.name || o) === 'color'; });
      if (idx === -1) return;
      var seen = {}, list = [];
      prod.variants.forEach(function (v) {
        var name = v.options[idx];
        if (v.available && !seen[norm(name)]) { seen[norm(name)] = 1; list.push(name); }
      });
      if (list.length < 2 || card.querySelector('.citric-colors')) return;
      var box = document.createElement('div');
      box.className = 'citric-colors';
      box.innerHTML = list.slice(0, 6).map(function (n) {
        var hex = hexFor(n) || '#bbb';
        return '<span title="' + n.replace(/"/g, '') + '" style="background:' + hex + '"></span>';
      }).join('') + '<small>' + list.length + ' colores</small>';
      var price = card.querySelector('product-price, .price');
      (price && price.parentNode ? price.parentNode : card).appendChild(box);
    });
  }
  function initColorDots(root) {
    // Horizon ya muestra sus propios círculos de color en las tarjetas: no duplicar.
    document.querySelectorAll('.citric-colors').forEach(function (e) { e.remove(); });
    // Si una tarjeta trae dos filas de círculos (p. ej. dos bloques de swatches), deja solo la primera.
    (root || document).querySelectorAll('product-card, .product-card, [class*="product-card"]').forEach(function (card) {
      var rows = Array.prototype.filter.call(card.querySelectorAll('[class*="swatches"], swatches-variant-picker-component, .citric-colors'), function (el) {
        var p = el.parentElement;
        while (p && p !== card) { if (p.matches('[class*="swatches"], swatches-variant-picker-component')) return false; p = p.parentElement; }
        return true;
      });
      rows.slice(1).forEach(function (el) { el.style.setProperty('display', 'none', 'important'); });
    });
    return;
    (root || document).querySelectorAll('product-card, .product-card').forEach(colorDots);
  }

  /* Ficha de producto: los botones de Color se ven como círculos con el color (si el color no se reconoce, queda el botón de texto) */
  function oneHex(k) {
    k = k.trim();
    return COLOR_HEX[k] || COLOR_HEX[k.split(' ')[0]] || null;
  }
  /* Colores compuestos ("Dorado/Rojo"): círculo partido en dos colores */
  function hexFor(name) {
    var k = norm(name);
    if (COLOR_HEX[k]) return COLOR_HEX[k];
    var parts = k.split('/');
    if (parts.length > 1) {
      var a = oneHex(parts[0]), b = oneHex(parts[1]);
      if (a && b && a.indexOf('gradient') === -1 && b.indexOf('gradient') === -1) return 'linear-gradient(135deg,' + a + ' 50%,' + b + ' 50%)';
      return a || b;
    }
    return oneHex(k);
  }
  function initSwatches() {
    document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset, fieldset[class*="variant-option"]').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || norm(legend.textContent).indexOf('color') === -1) return;
      var checkedName = '';
      var radios = fs.querySelectorAll('input[type="radio"]');
      /* Si algún color no se reconoce, todos se quedan como texto (no mezclar círculos y letras) */
      for (var i = 0; i < radios.length; i++) { if (!hexFor(radios[i].value)) return; }
      radios.forEach(function (inp) {
        var label = inp.closest('label') || (inp.id && fs.querySelector('label[for="' + inp.id + '"]'));
        var hex = hexFor(inp.value);
        if (!label || !hex) return;
        if (!label.classList.contains('citric-swatch')) {
          label.classList.add('citric-swatch');
          label.style.setProperty('--sw', hex);
          label.title = inp.value;
        }
        if (inp.checked) checkedName = inp.value;
      });
      if (!fs.querySelector('.citric-swatch')) return;
      var tag = legend.querySelector('.citric-swatch-name');
      if (!tag) { tag = document.createElement('span'); tag.className = 'citric-swatch-name'; legend.appendChild(tag); }
      if (tag.textContent !== (checkedName ? ': ' + checkedName : '')) tag.textContent = checkedName ? ': ' + checkedName : '';
    });
  }
  var css = document.createElement('style');
  css.textContent = '.citric-brand-search__results{display:none;max-height:60vh;overflow:auto;margin-top:8px;border:1px solid #eee;border-radius:12px;background:#fff}' +
    '.citric-brand-search__results a{display:block;padding:12px 14px;border-bottom:1px solid #f0f0f0;color:#111;text-decoration:none;font-size:15px}' +
    '.citric-brand-search__empty{display:none;padding:10px 4px;color:#777;font-size:14px}' +
    '.citric-brand-search{list-style:none;padding:8px 0 10px}.citric-brand-search input{width:100%;box-sizing:border-box;padding:12px 16px;border:1px solid #ddd;border-radius:999px;font-size:16px;background:#fff;pointer-events:auto;user-select:text;-webkit-user-select:text}' +
    '.citric-colors,.citric-chips{display:none!important}.citric-colors-x{display:flex;align-items:center;gap:4px;margin-top:6px;flex-wrap:wrap}.citric-colors span{width:14px;height:14px;border-radius:50%;border:1px solid #ccc;display:inline-block}.citric-colors small{font-size:11px;color:#666;margin-left:2px}' +
    'label.citric-swatch{width:34px!important;height:34px!important;min-width:0!important;flex:0 0 auto!important;padding:0!important;border-radius:50%!important;background:var(--sw)!important;border:1px solid #ccc!important;color:transparent!important;font-size:0!important;overflow:hidden;box-shadow:none!important}' +
    'label.citric-swatch *{color:transparent!important;font-size:0!important;background:transparent!important}' +
    'label.citric-swatch{position:relative}label.citric-swatch input{opacity:0!important;position:absolute;inset:0;margin:0;cursor:pointer}' +
    'label.citric-swatch:has(input:checked){outline:2px solid #111;outline-offset:3px}' +
    'label.citric-swatch:has(input:disabled){opacity:.35}' +
    'fieldset:has(.citric-swatch){display:flex;flex-wrap:wrap;gap:10px}fieldset:has(.citric-swatch) legend{width:100%}';
  document.head.appendChild(css);
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-picker, .variant-picker, product-form, form[action*="/cart/add"]')) setTimeout(function () { filterMediaByColor(); initSwatches(); }, 150);
  });

  /* INICIO en la misma fila que Ofertas / Marcas / Contacto, con letras más chicas */
  function initMenuPill() {
    if (document.querySelector('.citric-menu-pill')) return;
    var all = Array.prototype.filter.call(document.querySelectorAll('a'), function (a) {
      return norm(a.textContent) === 'ofertas' && a.offsetParent !== null &&
        !a.closest('dialog, details, nav[class*="drawer" i], [class*="drawer" i], footer, .citric-tabbar');
    });
    /* primero la fila de botones fuera del encabezado; si la fila ahora vive dentro del encabezado, se usa esa */
    var links = all.filter(function (a) { return !a.closest('header, #header-component'); });
    if (!links.length) links = all;
    if (!links.length) return;
    var first = links[0], bar = first.parentElement;
    while (bar && bar.children.length < 2 && bar.parentElement) { first = bar; bar = bar.parentElement; }
    if (!bar) return;
    bar.classList.add('citric-pill-bar');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'citric-menu-pill ' + (links[0].className || '');
    btn.setAttribute('style', links[0].getAttribute('style') || '');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7h16M4 12h16M4 17h16"/></svg><span>Inicio</span>';
    btn.addEventListener('click', function () {
      var t = document.querySelector('#header-component .header__icon--menu, #header-component [aria-controls*="menu" i], #header-component summary');
      if (t) t.click();
    });
    bar.insertBefore(btn, bar.firstElementChild);
    document.documentElement.classList.add('citric-has-menu-pill');
  }
  var css2 = document.createElement('style');
  css2.textContent =
    '.citric-pill-bar{align-items:center}' +
    '.citric-pill-bar>a,.citric-pill-bar>button,.citric-pill-bar>*>a{font-size:12px!important;padding:6px 14px!important;letter-spacing:.02em}' +
    '.citric-menu-pill{display:inline-flex!important;align-items:center;gap:6px;cursor:pointer;background:#111!important;color:#fff!important;border:1px solid #111!important;border-radius:999px;font-weight:700;text-transform:uppercase}' +
    '.citric-menu-pill span{color:#fff!important;-webkit-text-fill-color:#fff!important;background:none!important;font-family:inherit!important;letter-spacing:.04em}' +
    '@media (min-width:750px){.citric-has-menu-pill #header-component .header__icon--menu{visibility:hidden}}';
  document.head.appendChild(css2);

  /* Celular: el texto "INICIO" junto al menú del encabezado se encimaba con la lupa. En celular se hace más chico y la lupa se separa */
  function fixHeaderInicio() {
    var header = document.querySelector('#header-component') || document.querySelector('header');
    if (!header) return;
    /* Texto suelto "INICIO" (aunque esté junto al ícono dentro del mismo botón): se envuelve para poder ocultarlo */
    var walker = document.createTreeWalker(header, NodeFilter.SHOW_TEXT, null), nodes = [], t;
    while ((t = walker.nextNode())) { if (norm(t.nodeValue) === 'inicio' && !(t.parentNode.classList && t.parentNode.classList.contains('citric-inicio-label'))) nodes.push(t); }
    nodes.forEach(function (node) {
      var span = document.createElement('span');
      span.className = 'citric-inicio-label';
      node.parentNode.insertBefore(span, node);
      span.appendChild(node);
    });
    /* "INICIO" puesto con CSS (content:) */
    header.querySelectorAll('*').forEach(function (el) {
      if (el.classList.contains('citric-inicio-pseudo')) return;
      ['::before', '::after'].forEach(function (p) {
        var c = '';
        try { c = getComputedStyle(el, p).content; } catch (e) { return; }
        if (c && c !== 'none' && /inicio/i.test(c)) el.classList.add('citric-inicio-pseudo');
      });
    });
  }
  var css3 = document.createElement('style');
  css3.textContent = '@media (max-width:749px){' +
    'html body .citric-inicio-label{font-size:11px!important;letter-spacing:.03em;margin-left:4px;white-space:nowrap;line-height:1}' +
    'html body #header-component .citric-inicio-pseudo::before,html body #header-component .citric-inicio-pseudo::after{font-size:11px!important;letter-spacing:.03em;white-space:nowrap}' +
    'html body #header-component .search-action,html body #header-component search-button,html body #header-component [aria-controls*="search" i]{margin-left:14px!important}}';
  document.head.appendChild(css3);

  /* Celular: productos más chicos (2 por pantalla en los carruseles de producto) */
  var css4 = document.createElement('style');
  css4.textContent = '@media (max-width:749px){' +
    'slideshow-slide:has(product-card),slideshow-slide:has(.product-card){flex:0 0 calc(50% - 6px)!important;width:calc(50% - 6px)!important;max-width:calc(50% - 6px)!important}' +
    'product-card [class*="title"],.product-card [class*="title"]{font-size:13px!important;line-height:1.3!important}' +
    'product-card product-price,product-card .price,.product-card .price{font-size:13px!important}}';
  document.head.appendChild(css4);

  /* Celular: el botón de WhatsApp y el aviso de ofertas tapaban la barra inferior; se suben arriba de ella */
  function liftFloating() {
    if (window.innerWidth >= 750) return;
    var bar = document.querySelector('.citric-tabbar');
    if (!bar || !bar.offsetHeight) return;
    var h = bar.offsetHeight;
    var cand = Array.prototype.slice.call(document.body.children).concat(Array.prototype.slice.call(
      document.querySelectorAll('[class*="whatsapp" i], [id*="whatsapp" i], [class*="eaze" i], [id*="eaze" i], shopify-forms-embed, [class*="shopify-forms" i]')));
    cand.forEach(function (el) {
      if (el === bar || el.dataset.citricLift || bar.contains(el) || el.contains(bar)) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (!r.height || r.height > window.innerHeight * 0.5 || r.bottom < window.innerHeight - h - 4) return;
      el.dataset.citricLift = '1';
      el.style.setProperty('bottom', ((parseFloat(cs.bottom) || 0) + h + 8) + 'px', 'important');
    });
  }

  /* Dentro de una marca, las secciones se llaman sin la marca: "Jersey PUMA" -> "Jersey" (menú y título de la colección).
     La lista de marcas se lee del propio menú "Todas las marcas" */
  function brandNames() {
    var names = [];
    document.querySelectorAll('.citric-brand-list > li').forEach(function (li) {
      var lab = li.querySelector('a, summary, button');
      var t = lab && lab.textContent.replace(/\s+/g, ' ').trim();
      if (t && t.length > 1) names.push(t);
    });
    return names.sort(function (a, b) { return b.length - a.length; });
  }
  function stripBrand(text, brand) {
    var esc = brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var out = text.replace(new RegExp('(^|\\s)' + esc + '(?=\\s|$)', 'i'), ' ').replace(/\s+/g, ' ').trim();
    return out && out !== text.trim() ? out : null;
  }
  function labelOf(li) {
    var lab = li && li.querySelector(':scope > a, :scope > details > summary, :scope > summary, :scope > button, :scope > div > a');
    return lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function initStripBrand() {
    var brands = brandNames();
    if (!brands.length) return;
    var isBrand = {}; brands.forEach(function (b) { isBrand[norm(b)] = b; });
    document.querySelectorAll('header li li a, [class*="drawer" i] li li a, [class*="menu" i] li li a').forEach(function (a) {
      if (a.dataset.citricStrip || a.closest('.citric-brand-search')) return;
      var li = a.closest('li'), parentLi = li && li.parentElement && li.parentElement.closest('li');
      var brand = isBrand[norm(labelOf(parentLi))];
      if (!brand) return;
      a.dataset.citricStrip = '1';
      var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null), t;
      while ((t = walker.nextNode())) { var n = stripBrand(t.nodeValue, brand); if (n) t.nodeValue = t.nodeValue.replace(t.nodeValue.trim(), n); }
    });
    if (location.pathname.indexOf('/collections/') !== -1) {
      document.querySelectorAll('main h1').forEach(function (h) {
        if (h.dataset.citricStrip) return;
        h.dataset.citricStrip = '1';
        var txt = h.textContent.replace(/\s+/g, ' ').trim();
        if (isBrand[norm(txt)]) return;
        for (var i = 0; i < brands.length; i++) {
          var n = stripBrand(txt, brands[i]);
          if (n) { h.textContent = n; break; }
        }
      });
    }
  }

  /* Menú lateral: letra de 16 px. Se ubica por el item "Todas las marcas" porque el tema no usa clases fijas */
  function initDrawerFont() {
    if (!document.getElementById('citric-drawer-font')) {
      var st = document.createElement('style');
      st.id = 'citric-drawer-font';
      st.textContent = '.citric-drawer-menu, .citric-drawer-menu *:not(input):not(svg):not(path){font-family:Montserrat,sans-serif!important;font-size:16px!important;font-weight:500!important;line-height:1.3!important;letter-spacing:0!important;text-transform:none!important;color:#202020}' +
        '.citric-drawer-menu > li > a, .citric-drawer-menu > li > a *, .citric-drawer-menu > li > details, .citric-drawer-menu > li > details > summary, .citric-drawer-menu > li > details > summary *, .citric-drawer-menu > li > button, .citric-drawer-menu > li > button *, .citric-drawer-menu > li > div, .citric-drawer-menu > li > div > a, .citric-drawer-menu > li > div > a *{padding-top:0!important;padding-bottom:0!important;margin-top:0!important;margin-bottom:0!important;min-height:0!important;height:auto!important}' +
        '.citric-drawer-menu > li{padding:10px 0!important;margin:0!important;min-height:0!important;height:auto!important}' +
        '.citric-drawer-menu ul li{padding:6px 0!important}';
      document.head.appendChild(st);
    }
    document.querySelectorAll('[id*="todas-las-marcas" i]').forEach(function (t) {
      var li = t.closest('li'); var ul = li && li.parentElement;
      if (ul && !ul.classList.contains('citric-brand-list')) ul.classList.add('citric-drawer-menu');
    });
  }

  /* "Todos" hasta arriba dentro de cada marca de "Todas las marcas" (Adidas › Todos, Jerseys, Pants y Conjuntos).
     Liga a la colección de la marca (/collections/<marca>) y si no existe, a todos los productos de esa marca (vendors). */
  var brandUrlCache = {};
  function slugify(s) {
    return norm(s).replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function initBrandTodos() {
    document.querySelectorAll('.citric-brand-list > li').forEach(function (li) {
      if (li.classList.contains('citric-brand-search')) return;
      var sub = li.querySelector('ul');
      if (!sub || sub.dataset.citricTodos) return;
      var first = sub.querySelector(':scope > li');
      if (!first || !first.querySelector('a')) return;
      sub.dataset.citricTodos = '1';
      var lab = li.querySelector('summary, button, a');
      var brand = lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!brand) return;
      var own = Array.prototype.find.call(li.querySelectorAll('a[href*="/collections/"]'), function (a) { return !sub.contains(a); });
      var item = first.cloneNode(true);
      item.classList.add('citric-todos');
      var a = item.querySelector('a');
      a.removeAttribute('aria-current');
      a.textContent = 'Todos';
      a.href = own ? own.getAttribute('href') : '/collections/vendors?q=' + encodeURIComponent(brand);
      sub.insertBefore(item, sub.firstElementChild);
      if (own) return;
      var slug = slugify(brand);
      var p = brandUrlCache[slug] || (brandUrlCache[slug] = fetch('/collections/' + slug + '.json').then(function (r) { return r.ok ? '/collections/' + slug : null; }).catch(function () { return null; }));
      p.then(function (url) { if (url) a.href = url; });
    });
  }

  function init() { initBrandSearch(); initFlashTimers(); initTabbar(); filterMediaByColor(); initColorDots(); initSwatches(); initMenuPill(); fixHeaderInicio(); liftFloating(); initStripBrand(); initDrawerFont(); initBrandTodos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initBrandSearch(e.target); });
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; initBrandSearch(); filterMediaByColor(); initColorDots(); initSwatches(); initMenuPill(); fixHeaderInicio(); liftFloating(); initStripBrand(); initDrawerFont(); initBrandTodos(); }, 300);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
